<div class="alert-popup-container">

    <!-- Header -->
    <div class="alert-popup-header">
        <div class="alert-headerline-left">
            <span class="title">Notificaties</span>
        </div>
        <div class="alert-headerline-right">
            <button mat-icon-button routerLink="/alerts" class="alert-header-icon">
                <mat-icon class="alert-popup-icon" color="primary" matTooltip="Melding instellingen">settings</mat-icon>
            </button>

            <button mat-icon-button routerLink="/alerts" class="alert-header-icon">
                <mat-icon class="alert-popup-icon" color="primary" matTooltip="Alle Notificaties Weergeven">list_alt</mat-icon>
            </button>
        </div>
        <div style="clear: both;"></div>
    </div>  

    <div class="loading-message" *ngIf="loading"> 
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>

    <!-- Notification List -->
    <div *ngIf="!loading" class="alert-popup-notifications content">

        <div class="no-alerts-container" *ngIf="!alerts">
            <mat-icon class="no-alerts-icon">notifications_none</mat-icon>
            <h3>How unfortunate</h3>
            <div>You have no new messages at the moment.</div>
            <small>Check back later or subscribe to more sources to recieve some!</small>
        </div>

        <mat-nav-list dense *ngIf="alerts">
            <mat-list-item [routerLink]="['/alerts/detail', alert.id]" *ngFor="let alert of alerts" class="alerts-popup-list-item">
                <mat-icon matListIcon [style.color]="getColor(alert)">{{getIcon(alert)}}</mat-icon>

                <div matLine class="alert-popup-firstline">
                    <span class="alert-popup-title">{{alert.title}}</span>
                    <span class="alert-date">{{alert.date | timeAgo}}</span>
                    <div style="clear: both;"></div>
                </div>

                <p matLine>
                    <span> {{alert.message}} </span>
                </p>
            </mat-list-item>
        </mat-nav-list>
    </div>
</div>